/*
 * @Description: 商家推广-切换门店列表
 * @Author: maowy
 * @Date: 2021-02-01 18:28:16
 * @LastEditTime: 2020-02-01 18:28:16
 * @LastEditors: maowy
 */
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    getSpecSstores
} from '@/models/storeList'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import customSingularStoreListSearch from './customSingularStoreListSearch/customSingularStoreListSearch'
export default {
    name: viewName.customSingularStoreList,
    components: {
        infiniteLoadData,
        customSingularStoreListSearch
    },
    data () {
        return {
            clientHeight: 0,
            currentSelected: '',
            count: 0,
            nearbySstoresList: [],
            isload: false,
            param: {
                topic_id: '',
                topic_type: '',
                latitude: '',
                longitude: '',
                page: 0,
                pagesize: 20,
            },
            isSelectSidBack: false, // 是否选择门店
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {
        const { topic_id, topic_type, latitude, longitude } = this.$route.query
        this.$emit('setHeader', {
            title: '周边门店',
            showHeader: true,
            showLeft: true,
            hasSearch: false
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        Object.assign(this.param, {
            topic_id,
            topic_type,
            latitude,
            longitude,
        })
    },
    methods: {
        ...mapActions([
            'getSpecSstores',
            'setAppClass'
        ]),
        initParams () {
            Object.assign(this.param, {
                sstore_name: '',
                page: 0,
                pagesize: 20,
            })
            this.nearbySstoresList = []
        },
        onSearch (name) {
            if (!name) {
                this.$toast('请输入门店名称')
                return
            }
            this.initParams()
            Object.assign(this.param, {
                sstore_name: name
            })
            this.getPageList()
        },
        // 获取门店-分页
        getPageList () {
            if (this.nearbySstoresList.length <= this.count) {
                this.param.page++
                this.isload = true
                this.getData(this.param)
            } else {
                //  到底部了。
                // this.getData(param)
                this.isload = false
            }
        },
        getData () {
            getSpecSstores(this.param).then(res => {
                const { list, total_count } = res
                this.count = total_count
                this.nearbySstoresList = this.nearbySstoresList.concat(list)
                this.$nextTick(() => {
                    this.clientHeight = Number(document.querySelector('.searchBox').clientHeight) + Number(document.querySelector('.store-list-count').clientHeight)
                })
                // 返回数据 < 最大条目数
                if (list.length < this.param.pagesize) {
                    this.isload = false
                } else {
                    this.isload = true
                }
            }).catch(_ => {
                this.isload = false
            })
        },
        changeSelected (id) {
            if (id === this.currentSelected) {
                this.currentSelected = ''
            } else {
                this.currentSelected = id
            }
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getPageList()
        },
        /**
         * 监听是否初始化成功
         */
        init (scroll) {
            this.scroll = scroll
            // this.getPageList()
        },
        selectedStore (item) {
            let { topic_id } = this.$route.query
            if (item) {
                let jumpParam = {
                    sstore_id: item.id,
                    topic_id,
                    isSelectSidBack: true
                }
                this.$router.push({
                    path: '/customSingularDetail',
                    query: jumpParam
                })
            }
        },
    },
}
